<template>
  <div>
    <div class="projects-grid">
      <CoverPhoto
        v-for="(project, index) in projects"
        :key="index"
        :project="project"
        :cover="project.cover"
        />
    </div>

    <div class="projects-load" :class="{'is-loading': isLoading}"></div>
  </div>
</template>

<script>
import CoverPhoto from './CoverPhoto'
import lozad from 'lozad'

export default {
  name: 'ProjectsGrid',

  components: {
    CoverPhoto
  },

  data() {
    return {
      projects: [],
      isLoading: false,
      page: 0,
      visibleProjects: []
    }
  },

  methods: {
    loadPage: function() {
      this.page += 1

      let projects = [...this.projects]

      this.projects = [...this.projects, ...projects]

      this.isLoading = false

      document.documentElement.classList.toggle('is-inverted')
    }
  },

  mounted() {
    window.scrollTo(0, 0)

    const lazyLoader = lozad('.project-item img:not([data-loaded])')
    lazyLoader.observe()

    const loadObserver = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting && !this.isLoading) {
        this.isLoading = true
        this.loadPage()

        setTimeout(lazyLoader.observe, 250)
      }
    })

    loadObserver.observe(document.querySelector('.projects-load'))
  },

  created() {
    const initialData = JSON.parse(document.getElementById('projects-data').textContent)

    this.projects = initialData.projects
  }
}
</script>
